
import { useConnectionStatus } from '@/hooks/stripe/useConnectionStatus';
import { useConnectionRefresh } from '@/hooks/stripe/useConnectionRefresh';
import { useConnectionManagement } from '@/hooks/stripe/useConnectionManagement';

/**
 * Main hook that orchestrates Stripe connection functionality using smaller, focused hooks
 */
export function useStripeConnection() {
  // Get connection status
  const { 
    isConnected, 
    accountId, 
    isLoading, 
    configError, 
    checkConnection,
    clearCache 
  } = useConnectionStatus();
  
  // Set up connection refresh
  const { refreshConnection } = useConnectionRefresh(
    checkConnection, 
    clearCache,
    isConnected
  );
  
  // Set up connection management
  const { 
    isConnecting, 
    handleConnect, 
    handleDisconnect 
  } = useConnectionManagement(
    checkConnection,
    clearCache
  );

  return {
    isConnected,
    accountId,
    isConnecting,
    isLoading,
    configError,
    handleConnect,
    handleDisconnect,
    refreshConnection,
    disconnectError: null
  };
}
